import { TrackingProduct } from '@monolith/legacy/types/tracking-product';

type Option = {
  id: number;
  name: string;
};

export type ProductProperty = { option?: Option; quantity?: number } & Pick<
  TrackingProduct,
  'id' | 'name' | 'wholesalePrice' | 'position' | 'uuid'
>;

export function createProductProperty({ id, name, wholesalePrice, position, option, uuid }: ProductProperty): ProductProperty {
  const product: ProductProperty = {
    id,
    name,
    wholesalePrice,
    uuid
  };

  if (position !== undefined) {
    product.position = position;
  }

  if (option) {
    product.option = {
      id: option.id,
      name: option.name,
    };
  }
  return product;
}
